<div class="p-5"></div>
<div class="container">
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
            <div class="border p-2">
                <div class="text-center">
                    <h3 class="">Welcome</h3>
                    <p class="font-9 font-w">Reset Password</p>
                
                </div>
                <p class="font-9">You have requested to reset the password for user associated with    ________@amnex.com</p>
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="font-9">
                    <div class="mb-3 mt-3">
                      <label for="password" class="form-label">New password</label>
                      <input 
                      type="text" 
                      formControlName="password" 
                      class="form-control" 
                      placeholder="Enter your password" 
                      [ngClass]="{ 'is-invalid': submitted && f.password.errors }" 
                      required />
                      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                          <div *ngIf="f.password.errors.required">password is required</div>
                      </div>
                    </div>
                   <br>
                   <div class="mb-3 mt-3">
                    <label for="password" class="form-label">Retype New password</label>
                    <input 
                    type="text" 
                    formControlName="rePassword" 
                    class="form-control" 
                    placeholder="Enter your Password" 
                    [ngClass]="{ 'is-invalid': submitted && f.rePassword.errors }" 
                    required />
                    <div *ngIf="submitted && f.rePassword.errors" class="invalid-feedback">
                        <div *ngIf="f.rePassword.errors.required">Repassword is required</div>
                    </div>
                  </div>
                 <br>
                    
                    <button type="submit" class="btn btn-info btn-block ">Reset My Password</button>
  
                  </form>
            </div>
        </div>
        <div class="col-md-4"></div>
    </div>
</div>